import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "reusable-comment flex flex-col" }
const _hoisted_2 = { class: "flex items-start" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["contenteditable"]

import { ref, computed } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'commentField',
  props: ["placeholder", "iconSize", "minimalButton"],
  emits: ["commentSubmitted"],
  setup(__props, { emit: __emit }) {

const store = useStore()


const comment = ref<string>("")
const user = computed(() => ({
  profileImage: store.getters['user/userProfile'].picture
}))
const isEditingComment = ref<boolean>(false)
const isSendingComment = ref<boolean>(false)
const commentArea = ref(null)
const commentMinHeight = ref<number>(40); // Set an initial min-height value

const props = __props
const emits = __emit


const handleFocusOut = () => {
    if(!isSendingComment.value){
        const comment = commentArea.value?.textContent
        commentArea.value.textContent = comment
        isEditingComment.value = false
    }

    if(commentArea.value.textContent === ""){
        commentArea.value.textContent = props.placeholder
        commentMinHeight.value = 40
    }
}

const iconSize = computed(() => {
    if(props.iconSize === "mini"){
        return "rounded-image-mini"
    } else if(props.iconSize === "smaller"){
        return "rounded-image-smaller"
    } else if (props.iconSize === 'none'){
        return "!hidden"
    }
    else {
        return "rounded-image"
    }
})

const handleClick = () => {
    const comment = commentArea.value
    if(comment.innerText === props.placeholder){
        comment.innerText = ""
    }
    isEditingComment.value = true
}

const submitCommentAndResetField = async () => {
    isSendingComment.value = true
    const commentAreaValue =  commentArea.value.textContent
    if(commentAreaValue.length > 3 && commentAreaValue !== props.placeholder){
        comment.value = commentAreaValue
       
        emits("commentSubmitted", comment.value)

        isEditingComment.value = false
        commentArea.value.textContent = props.placeholder
        commentMinHeight.value = 40

    } else {
        alert("Yorumunuz en az 3 karakterden oluşmalıdır.")
    }
}

const updateCommentHeight = () => {
  if (commentArea.value) {
    const contentHeight = commentArea.value.scrollHeight;
    commentMinHeight.value = Math.max(contentHeight, 40); // Set a minimum height
  }
};

const hardCancelComment = () => {
    commentArea.value.textContent = props.placeholder
    isEditingComment.value = false
    commentMinHeight.value = 40

}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: _normalizeClass([iconSize.value, "rounded-image-smaller mr-6"]),
        referrerpolicy: "no-referrer",
        src: user.value.profileImage,
        alt: "Profil Resmi"
      }, null, 10, _hoisted_3),
      _createElementVNode("div", {
        class: "comment-field-area",
        ref_key: "commentArea",
        ref: commentArea,
        onClick: handleClick,
        onBlur: handleFocusOut,
        onInput: updateCommentHeight,
        onKeyup: _withKeys(hardCancelComment, ["esc"]),
        tabindex: "0",
        style: _normalizeStyle({ minHeight: commentMinHeight.value + 'px' }),
        contenteditable: isEditingComment.value
      }, _toDisplayString(props.placeholder), 45, _hoisted_4)
    ]),
    _createVNode(_Transition, {
      type: "animation",
      "enter-active-class": "animate__animated animate__fadeInDown",
      "leave-active-class": "animate__animated animate__fadeOutUp animate__fast",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (isEditingComment.value && __props.minimalButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              tabindex: "-1",
              class: "ac-subtle-button mt-4 self-start",
              onClick: submitCommentAndResetField
            }, " Gönder "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      type: "animation",
      "enter-active-class": "animate__animated animate__fadeInDown",
      "leave-active-class": "animate__animated animate__fadeOutUp animate__fast",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (isEditingComment.value && !__props.minimalButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              tabindex: "-1",
              class: "ac-primary-button ml-12 mt-8 self-start",
              onClick: submitCommentAndResetField
            }, " Gönder "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})